import { AxiosPromise } from "axios";
import { ApiRequestAdapter } from "../../../common/api/ApiRequestAdapter";
import { apiService } from "../../../common/api/apiService";
import { HttpMethod } from "../../../common/api/http";
import { RecalculatePredictedCommissions } from "./types";

const RECALCULATE_PREDICTED_COMMISSIONS = ApiRequestAdapter.create(
  "/contracts/recalculate-predicted-commissions",
  HttpMethod.POST,
);

export const predictedCommissionsApi = {
  recalculatePredictedCommissions: (request: RecalculatePredictedCommissions): AxiosPromise<number> => {
    return apiService.post(RECALCULATE_PREDICTED_COMMISSIONS.url, request);
  },
};
